/* eslint-disable */ import { entities as v1 } from './versions/v1.js';
import { entities as v2 } from './versions/v2.js';
export * from './versions/v2.js';
export const modelVersions = {
    1: v1,
    2: v2
};

//# sourceMappingURL=index.js.map